// Angular
import { Injectable } from '@angular/core';

@Injectable()
export class EncryptionService {
  private readonly ENCRYPTION_PREFIX = 'enc:';
  private readonly SALT = 'sms-ir-secure';

  encrypt(value: string): string {
    if (!value) {
      return value;
    }

    try {
      const encoded = btoa(
        this.xorEncrypt(value, this.SALT)
      );
      return `${this.ENCRYPTION_PREFIX}${encoded}`;
    } catch (error) {
      console.error('Encryption error:', error);
      return value; // Return original if encryption fails
    }
  }

  decrypt(encryptedValue: string): string {
    if (!encryptedValue || !encryptedValue.startsWith(this.ENCRYPTION_PREFIX)) {
      return encryptedValue;
    }

    try {
      const encoded = encryptedValue.replace(this.ENCRYPTION_PREFIX, '');
      const decoded = atob(encoded);
      return this.xorDecrypt(decoded, this.SALT);
    } catch (error) {
      console.error('Decryption error:', error);
      return encryptedValue; // Return original if decryption fails
    }
  }

  private xorEncrypt(text: string, key: string): string {
    let result = '';
    for (let i = 0; i < text.length; i++) {
      result += String.fromCharCode(
        text.charCodeAt(i) ^ key.charCodeAt(i % key.length)
      );
    }
    return result;
  }

  private xorDecrypt(encryptedText: string, key: string): string {
    return this.xorEncrypt(encryptedText, key);
  }
}

